/**
 * @file AreaRow.tsx
 * @description Строка «Шапка» / «Подвал» в структуре страницы конструктора
 * (phase19.16 Р1-6а; uiux-builder-shell.md §2.1, §3.2): значок общей
 * области, пометка «все стр.» — правка действует на весь сайт. Нажатие
 * выбирает область: справа её панель, канва прокручивается к ней.
 */

import { ChevronRight, PanelBottom, PanelTop } from "lucide-react";

import { useBuilder } from "../builder-context";
import type { CanvasAreaKey } from "../../../lib/site-builder/selection";
import { cn } from "@/lib/utils";

const AREA_META: Readonly<Record<CanvasAreaKey, { label: string; icon: typeof PanelTop }>> = {
  header: { label: "Шапка", icon: PanelTop },
  footer: { label: "Подвал", icon: PanelBottom },
};

export function AreaRow({ area, selected }: { area: CanvasAreaKey; selected: boolean }) {
  const b = useBuilder();
  const meta = AREA_META[area];
  const Icon = meta.icon;
  return (
    <button
      type="button"
      onClick={() => void b.select({ sel: { kind: "area", area }, panel: null })}
      aria-current={selected ? "true" : undefined}
      className={cn(
        "flex min-h-12 w-full items-center gap-3 rounded-md px-3 text-left outline-none focus-visible:ring-2 focus-visible:ring-ring",
        selected ? "bg-primary/10" : "hover:bg-surface-low",
      )}
    >
      <Icon aria-hidden className="size-4 shrink-0 text-primary" />
      <span className="type-body flex-1 font-medium text-on-surface">{meta.label}</span>
      <span className="type-caption text-on-surface-variant">все стр.</span>
      <ChevronRight aria-hidden className="size-4 text-on-surface-variant" />
    </button>
  );
}
